/**
 * Browser-side Stripe.js loader (LG-1033). One shared promise: Stripe.js is
 * a script tag under the hood, and `loadStripe` per mount would race
 * against itself. Server code must never import this — the publishable
 * key comes from `import.meta.env`, which only Vite fills in.
 */
import { loadStripe, type Stripe } from '@stripe/stripe-js'

export const STRIPE_PUBLISHABLE_KEY = import.meta.env
  .VITE_STRIPE_PUBLISHABLE_KEY as string | undefined

let stripePromise: Promise<Stripe | null> | undefined

/**
 * Resolves to `null` when the key is unset — callers render a loud
 * "payments aren't configured" state rather than an element that spins
 * forever.
 */
export function getStripe(): Promise<Stripe | null> {
  if (!stripePromise) {
    stripePromise = STRIPE_PUBLISHABLE_KEY
      ? loadStripe(STRIPE_PUBLISHABLE_KEY)
      : Promise.resolve(null)
  }
  return stripePromise
}
